module.exports = __webpack_public_path__ + "static/media/tackle@2x.fdae5fd3.png";